import { pipe } from 'fp-ts/lib/function';
import { array, failure, parse, struct, success } from 'io-ts/Decoder';

import { Point } from './Point';

const Points = pipe(
	array(Point),
	parse((points) =>
		points.length > 2 ? success(points) : failure(points, 'Polygon must have at least 3 points')
	)
);

export const Polygon = struct({
	points: Points,
});
